import { userRoutes } from "./userRoutes";
import { roles } from "constants/variables";

export const currentRoutesByRole = () => {
  const role = sessionStorage.getItem("userRole");

  return userRoutes[roles[role]?.key];
};
